module.exports = __webpack_public_path__ + "static/img/e6bdbc12fcb35ec3e3a9f1f09f2d4a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_03.png
// module id = OFrx
// module chunks = 1